import React, { useState } from "react";
import {
  Button,
  Box,
  Grid,
  TextField,
  IconButton,
  Typography,
  InputAdornment,
} from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import { useSelector } from "react-redux";
// import ContactNumber from "../CallDashbord/ContactNumber";

// const Contact_Number = [
//   {
//     name: "Jhon smith",
//     number: "+91 97134 55165",
//   },
// ];

const DialPad = ({
  dialNumber = "",
  setDialNumber = () => {},
  sendDTMF = () => {},
  handleDial = () => {},
}) => {
  const [showDialpad, setShowDialpad] = useState(true);
  const userInfo = useSelector((state) => state.userInfo.user);

  const buttons = [
    { number: "1", letters: "" },
    { number: "2", letters: "ABC" },
    { number: "3", letters: "DEF" },
    { number: "4", letters: "GHI" },
    { number: "5", letters: "JKL" },
    { number: "6", letters: "MNO" },
    { number: "7", letters: "PQRS" },
    { number: "8", letters: "TUV" },
    { number: "9", letters: "WXYZ" },
    { number: "*", letters: "" },
    { number: "0", letters: "+" },
    { number: "#", letters: "" },
  ];

  const handleAppendNumber = (number) => {
    sendDTMF(number);
    setDialNumber((prev) => prev + number);
  };

  // Toggle dialpad visibility
  const handleToggleDialpad = () => {
    setShowDialpad(!showDialpad);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        borderRadius: "20px",
        padding: "10px",
        // padding: 2,
      }}
    >
      <TextField
        fullWidth
        variant="standard"
        label="Phone number"
        value={dialNumber}
        // disabled={userInfo?.is_demo_account}
        onChange={(e) => setDialNumber(e.target.value)}
        sx={{ marginBottom: 2 }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton color="primary" onClick={handleDial} title="call">
                <PhoneIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />

      {/* Suggestions List */}
      {/* <Box sx={{ height: "150px" }}>
        <List sx={{ flex: 1, marginTop: 2 }}>
          {Contact_Number.map((number, index) => (
            <ContactNumber key={index} name={number?.name} number={number?.number} />
          ))}
        </List>
      </Box> */}

      {showDialpad && (
        <Box sx={{ marginBottom: 2 }}>
          <Grid container spacing={2}>
            {buttons.map((button, index) => (
              <Grid item xs={4} key={index}>
                <Button
                  variant="text"
                  color="inherit"
                  fullWidth
                  onClick={() => handleAppendNumber(button.number)}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    padding: 2,
                    height: "80px",
                  }}
                >
                  <Typography variant="h6">{button.number}</Typography>
                  <Typography variant="caption">{button.letters}</Typography>
                </Button>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      <Button onClick={handleToggleDialpad} sx={{ mt: 2 }}>
        {showDialpad ? "Hide keypad" : "Show keypad"}
      </Button>
    </Box>
  );
};

export default DialPad;
